import axios from 'axios'

const baseAPI = process.env.REACT_APP_BASE_API;

export const fetchSubcategory = (accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SUBCATEGORY_PENDING",
    });
    return axios({
      method: "get",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/subcategories`,
    })
      .then((x) => {
        dispatch({
          type: "FETCH_SUBCATEGORY_FULFILLED",
          payload: x.data,
        });
      })
      .catch((e) => {
        console.error(e);
        dispatch(createError(e?.response?.data || "Error 4123400"));
        dispatch({
          type: "FETCH_SUBCATEGORY_REJECTED",
          payload: e,
        });
      });
  };
};
